import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public get environment(): any {
    return {
        debug: true,
        production: false,
    };
  }
}